Util = require 'lib/util'
hasSelection = require 'lib/util/selection/has-selection'
React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_board_item_component')

module.exports = class extends React.Component
  # The definitive source of truth for all state is the Renderable object,
  # we use React's state just as a way to trigger re-rendering. Keep in sync
  # with the Renderable at all times.
  constructor: (props) ->
    super(props)

    @state = {
      selected: @props.item.selected
    }

  render: t.renderable ->
    { eventHandlers, item } = @props

    {
      prefs
      name
      selected
      source
    } = item
    orgDisplayName = source.getOrganization().get('displayName')
    orgName = source.getOrganization().get('name')
    backgroundImageThumbnail = Util.smallestPreviewBiggerThan(prefs.backgroundImageScaled, 400, 200)?.url ? prefs.backgroundImage
    boardThumbnailStyles = {}
    if backgroundImageThumbnail
      boardThumbnailStyles.backgroundImage = t.urlify(backgroundImageThumbnail)
    if prefs.backgroundColor
      boardThumbnailStyles.backgroundColor = prefs.backgroundColor

    t.div '.dashboard-list-item.dashboard-list-selectable.u-clearfix.dashboard-item-hoverable',
      class: t.classify('multiple-select-state-selected': selected)
      onMouseDown: (e) =>
        # Block text selection with shift so we can use it for item ranges
        if e.shiftKey
          e.preventDefault()
      onClick: (e) =>
        # If they've just selected text they're probably trying to copy a
        # board name, not select that board
        if hasSelection() && !e.shiftKey
          return
        # If they clicked the team name, they get sent to
        # that team's page and won't select the board
        if e.target.className.includes('board-org-name')
          return
        item.selected = !item.selected
        @setState(selected: item.selected)
        eventHandlers.onSelectCheckboxClick(item, selectRange: e.shiftKey)
    , =>
      t.div '.multiple-select-checkbox', ->
        t.icon 'check', class: 'multiple-select-checkbox-check'

      t.div '.board-item-thumbnail',
        style: boardThumbnailStyles

      t.div '.details.board-details', ->
        t.span '.board-name', ->
          t.text name

      t.div '.options.board-options', ->
        t.p '.option.status', ->
          t.span '.icon-sm.icon-organization'
          t.a
            class: 'board-org-name no-underline'
            href: "/#{ orgName }"
            title: orgName
          , ->
            t.text orgDisplayName

        t.p '.option.status', ->
          t.a '.u-float-right',
            href: '#'
            onClick: (e) ->
              e.stopPropagation()
              e.preventDefault()
              eventHandlers.onBoardDetailsPopoverClick(e.currentTarget, item)
          , ->
            t.span '.icon-sm.icon-information'



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/board-item-component.coffee